import { Link } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { openPortal } from "@/lib/billing";
import { Dawn, Arrow } from "@/components/hm/Basics";
import { RESOURCE_LANDINGS } from "@/screens/resources/landings";
import { useResourceStatus, isVisible } from "@/lib/resources";

export const NextStep = () => (
  <div className="next" data-testid="next-step">
    <Dawn />
    <div>
      <span className="chip">Tu siguiente paso · 8 min</span>
      <h3 data-testid="next-step-title">Lo que sientes tiene sentido</h3>
      <p className="text-muted" style={{ margin: 0, maxWidth: "60ch" }}>
        Este módulo es un espacio para entender con claridad lo que te está pasando por dentro. Si te sientes vacío, desconectado, confundido o más sensible de lo habitual, no es un error: es tu interior reorganizándose. Tu corazón está empezando a pedirte coherencia, verdad y dirección.
        <br /><br />Aquí encontrarás una explicación sencilla y profunda para comprender este momento sin miedo y para empezar a escucharte de una forma nueva.
        <br /><br />No estás roto. Estás cambiando. Y lo que sientes tiene sentido.
      </p>
    </div>
    <div style={{ display: "flex", gap: ".6rem", flexWrap: "wrap" }}>
      <Link to="/entender-lo-que-te-esta-pasando" className="btn btn-primary mag" data-testid="next-step-button">Empezar módulo <Arrow /></Link>
      <Link to="/recursos#respira" className="btn btn-ghost" data-testid="next-step-breathe">Respirar antes</Link>
    </div>
  </div>
);

export const PlanTile = () => {
  const { user } = useAuth();
  const until = user.paid_until && new Date(user.paid_until).toLocaleDateString("es-ES");
  return (
    <div className="tile" style={{ display: "grid", gap: ".8rem", alignContent: "space-between" }} data-testid="plan-status">
      {user.has_access ? (
        <div>
          <h4>Tu plan · {user.billing_interval === "year" ? "anual" : "mensual"}</h4>
          <p data-testid="plan-status-text">
            Tu plan: {user.plan_name}. {user.cancel_at_period_end ? `Lo has cancelado. Tienes acceso hasta el ${until}.` : `Se renueva cada ${user.billing_interval === "year" ? "año" : "mes"}. Próxima renovación: ${until}.`}
          </p>
        </div>
      ) : (
        <div><h4>Plan gratuito</h4><p data-testid="plan-status-text">Tienes el módulo de bienvenida. Elige un plan para abrir los otros cuatro y las sesiones en directo.</p></div>
      )}
      {user.has_subscription ? (
        <button className="btn btn-ghost btn-sm" style={{ justifySelf: "start" }} onClick={openPortal} data-testid="manage-plan-button">Gestionar o cancelar mi plan</button>
      ) : !user.has_access && (
        <Link to="/planes" className="btn btn-ghost btn-sm" style={{ justifySelf: "start" }} data-testid="dashboard-plans-link">Ver los planes</Link>
      )}
    </div>
  );
};

export const FreeResources = () => {
  const status = useResourceStatus();
  return (
  <section style={{ marginTop: 16 }} className="tile" data-testid="free-resources">
    <h4>Tus recursos gratuitos</h4>
    <p>Los tienes por haber creado tu cuenta.</p>
    <div className="free-res-list">
      {RESOURCE_LANDINGS.filter((r) => isVisible(status, r.slug)).map((r) => (
        <Link key={r.slug} to={`/recursos/${r.slug}`} className="free-res" data-testid={`free-resource-${r.slug}`}>
          <span><b>{r.cardTitle || r.title}</b><small data-testid={`free-resource-status-${r.slug}`}>{r.cta}</small></span><Arrow />
        </Link>
      ))}
    </div>
  </section>
  );
};
